import StackdriverErrorReporter from 'stackdriver-errors-js'
import Vue from 'vue'

interface Options {
    enabled: boolean
    apiKey: string
    projectId: string
    serviceName: string
    serviceVersion: string
}

function getOptions(): Options {
    return {
        enabled: process.env.VUE_APP_ENABLE_STACKDRIVER_ERROR_REPORTER === 'true',
        apiKey: process.env.VUE_APP_STACKDRIVER_API_KEY,
        projectId: process.env.VUE_APP_STACKDRIVER_PROJECT_ID,
        serviceName: process.env.VUE_APP_STACKDRIVER_SERVICE_NAME,
        serviceVersion: process.env.VUE_APP_STACKDRIVER_SERVICE_VERSION,
    }
}

export default class StackdriverErrorReporterPlugin {
    public install(app: typeof Vue): void {
        const options = getOptions()
        if (!options.enabled) {
            return
        }

        const errorReporter = new StackdriverErrorReporter()

        errorReporter.start({
            key: options.apiKey,
            projectId: options.projectId,
            service: options.serviceName,
            version: options.serviceVersion,
            reportUncaughtExceptions: false,
            reportUnhandledPromiseRejections: false,
        })

        const tryReportError = async (err: unknown) => {
            if (!(err instanceof Error) && typeof err !== 'string') {
                return
            }

            await errorReporter.report(err)
        }

        // O Vue não expõe o tratamento de erros padrão
        const vueLogError = async (err: Error, vm: Vue, info: string) => {
            if (process.env.NODE_ENV !== 'production') {
                app.util.warn(`Error in ${info}: "${err.toString()}"`, vm)
            }

            console.error(err)
        }

        app.config.errorHandler = async (err, vm, info) => {
            vueLogError(err, vm, info)

            await tryReportError(err)
        }
    }
}
